import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AdminAttempts() {
  const [rows, setRows] = useState(null);
  const nav = useNavigate();

  useEffect(() => { api.get("/admin/attempts").then((r) => setRows(r.data)); }, []);

  if (!rows) return <AdminLayout title="Exam attempts"><Loader2 className="w-6 h-6 animate-spin text-white/40" /></AdminLayout>;

  return (
    <AdminLayout title="Exam attempts">
      <div className="bg-white/4 border border-white/10 rounded-lg overflow-hidden">
        <table className="w-full text-sm" data-testid="attempts-table">
          <thead className="bg-white/5 text-xs uppercase tracking-widest text-white/50 font-mono">
            <tr>
              <th className="text-left px-4 py-3">Student</th>
              <th className="text-left px-4 py-3">Category</th>
              <th className="text-left px-4 py-3">Score</th>
              <th className="text-left px-4 py-3">Result</th>
              <th className="text-left px-4 py-3">Correct</th>
              <th className="text-left px-4 py-3">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} onClick={() => nav(`/admin/users/${r.user_id}`)}
                className="border-t border-white/8 hover:bg-white/5 cursor-pointer" data-testid={`attempt-row-${r.id}`}>
                <td className="px-4 py-3">
                  <div className="font-medium">{r.user_name}</div>
                  <div className="text-xs text-white/50">{r.user_email}</div>
                </td>
                <td className="px-4 py-3 font-mono text-xs">{r.category_code}</td>
                <td className="px-4 py-3 font-mono font-semibold">{r.score_pct}%</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] font-mono uppercase px-1.5 py-0.5 rounded ${r.passed ? "bg-emerald-500/15 text-emerald-400" : "bg-red-500/15 text-red-400"}`}>
                    {r.passed ? "Pass" : "Fail"}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs">{r.correct_count}/{r.total}</td>
                <td className="px-4 py-3 text-xs text-white/50 font-mono">{new Date(r.submitted_at).toLocaleString()}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-white/40">No exam attempts yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
